import React from 'react'
import ReactDOM from 'react-dom'
import Tippy from '@tippy.js/react'

export default class LabelWithHelp extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const tooltipContent = this.props.tooltipContent;
    const labelText = this.props.labelText;
    return(
      <React.Fragment>
        <label className='float-left'>{this.props.children} {/* float is to allow fro progress bar to be placed to side */}
          <Tippy
            content={tooltipContent}
            className="text-left"
            arrow={true}
            animation="scale"
            duration={[300, 100]}
            delay={[300, 0]}
            a11y={false}
          >
            <span> <i className='fas fa-question-circle pr-1'></i></span>
          </Tippy>
        </label>
      </React.Fragment>
    )
  }
}